<lib-input-wrapper [ionItemWrap]="ionItemWrap">
    <div [ngClass]="{ 'ion-margin-top': !ionItemWrap && !removeAddedSpacing }" class="full-width">
        <ng-content *ngIf="presentation === 'date' || presentation === 'month-year'">
            <ng-content *ngTemplateOutlet="date"></ng-content>
        </ng-content>

        <div *ngIf="presentation === 'time'">
            <ng-content *ngTemplateOutlet="time"></ng-content>
        </div>

        <ng-content select="[formMessages]"></ng-content>

        <div class="invalid-text">
            <ng-content select="[formErrorMessages]"></ng-content>
        </div>
    </div>
</lib-input-wrapper>

<ng-template #date>
    <lib-input-button
        [label]="label"
        [placeholder]="placeholder"
        [id]="id"
        [value]="selectedValue ? (selectedValue | date: dateTextFormat) : ''"
        [disabled]="disabled" />

    <ng-content *ngIf="modalType === 'modal'">
        <ng-content *ngTemplateOutlet="modal"></ng-content>
    </ng-content>

    <ng-content *ngIf="modalType === 'popover'">
        <ng-content *ngTemplateOutlet="popover"></ng-content>
    </ng-content>
</ng-template>

<ng-template #time>
    <lib-input-button
        [owlDateTimeTrigger]="dt1"
        [label]="label"
        [placeholder]="placeholder"
        [value]="selectedValue ? (selectedValue | date: dateTextFormat) : ''"
        [disabled]="disabled" />
    <input
        class="sr-only"
        [owlDateTime]="dt1"
        (dateTimeChange)="onTimeChange($event)"
        [min]="minStartTime"
        [max]="maxTime"
        [disabled]="disabled" />
    <owl-date-time
        #dt1
        pickerType="timer"
        [hour12Timer]="true"
        [stepMinute]="30"
        [startAt]="pickerStartAtTime"
        [disabled]="disabled" />
</ng-template>

<ng-template #modal>
    <ion-modal #dateModal [keepContentsMounted]="true" [trigger]="!disabled ? id : undefined" class="modal-datepicker">
        <ng-template>
            <ng-content *ngTemplateOutlet="datetimeInputItem"></ng-content>
        </ng-template>
    </ion-modal>
</ng-template>

<ng-template #popover>
    <ion-popover
        #dateModal
        [keepContentsMounted]="true"
        [trigger]="!disabled ? id : undefined"
        class="modal-datepicker">
        <ng-template>
            <ng-content *ngTemplateOutlet="datetimeInputItem"></ng-content>
        </ng-template>
    </ion-popover>
</ng-template>

<ng-template #datetimeInputItem>
    <ion-datetime
        [presentation]="presentation"
        [id]="datePickerId"
        [preferWheel]="preferWheel"
        [min]="pickerMinDate"
        [max]="pickerMaxDate"
        [dayValues]="dayValues"
        [value]="selectedValue"
        (ionChange)="onDatetimeChange($event)"
        [disabled]="disabled"
        #datePicker />
</ng-template>
